<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Contents</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">Chapter 1        The Race Riot of 1866</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">Chapter 2        His Daughter’s Honor</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">Chapter 3        Murder at the Peabody</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">Chapter 4        Tainted Love</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">Chapter 5        A Husband Scorned</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">Chapter 6        Murder by Mail</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">Chapter 7        Cruel and Unusual</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">Chapter 8        Mistaken Identity</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">Chapter 9        The Summer Avenue Slayer</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10      The Cigarette Girl</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11      Memphis’s Merry Widow</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12      The Assassination of a Dreamer</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13      Serial Killer of ’69</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14      The Ultimate Betrayal</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter 15      A Murder in Millington</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Chapter 16      The West Memphis Three</span></p>
<p class="toc1"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0226ba03